import React, {useContext} from "react";
import {UserContext} from "../common/UserContext";
import {TemplateContext} from "../common/TemplateContext";
import {BrandContext} from "../common/BrandContext";
import NavigateCourse from "../nav/NavigateCourse";
import Button from "../common/Button";

const SyllabusOverview = props => {
    const {user, setUser} = useContext(UserContext);
    const {isSeriesNavVisible, setSeriesNavVisible} = useContext(TemplateContext);
    const brandConfig = useContext(BrandContext);

    const handleChangeSyllabus = () => {
        setSeriesNavVisible(true)
    }

    return (
        <div>
            <NavigateCourse syllabusId={user.syllabusId} />
            <div className={'ch-dashboard-blk-footer align-right'}>
                <Button type="text"
                        onClick={() => handleChangeSyllabus()}>
                    <span>Change {brandConfig.syllabusName}</span>
                </Button>
            </div>
        </div>
    );
}

export default SyllabusOverview;